import { css } from "styled-components";
export const clearfix = css(["zoom:1;&::before,&::after{display:table;content:\"\";}&::after{clear:both;}"]);